import _styled from '@emotion/styled/base';
import { useEffect } from 'react';
import { Input } from '@bucketplace/commerce-admin-ui';
import 'lodash-es';
import '@bucketplace/ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import 'qs';
import 'query-string';
import { useFieldForm } from '../../../hooks/useFieldForm.js';
import '@bucketplace/bucket-log';
import { FieldItem } from '../../FieldItem.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RGB = {
  r: 'r',
  g: 'g',
  b: 'b'
};
var RGB_LENGTH = 3;
var INPUT_LABELS = [RGB.r, RGB.g, RGB.b];
function RgbInput(_ref) {
  var color = _ref.color,
    onChange = _ref.onChange;
  var _useFieldForm = useFieldForm(),
    fields = _useFieldForm.fields,
    register = _useFieldForm.register,
    onInputChange = _useFieldForm.onChange;
  var handleChangeInput = function handleChangeInput(rgbType, value) {
    onInputChange(rgbType, Math.min(+value, 255));
  };
  var handleBlurInput = function handleBlurInput() {
    var hexR = decimalToFormmatedHex(fields.r);
    var hexG = decimalToFormmatedHex(fields.g);
    var hexB = decimalToFormmatedHex(fields.b);
    onChange("#".concat(hexR).concat(hexG).concat(hexB));
  };
  useEffect(function () {
    INPUT_LABELS.forEach(function (label) {
      register(label, {
        defaultValue: color[label]
      });
    });
  }, []);
  useEffect(function () {
    INPUT_LABELS.forEach(function (label) {
      onInputChange(label, color[label]);
    });
  }, [color.r, color.g, color.b]);
  return jsx(InputRow, null, INPUT_LABELS.map(function (label) {
    return jsx(FieldItem, {
      key: "color_input_".concat(label),
      label: label.toUpperCase(),
      direction: "HORIZONTAL"
    }, jsx(Input, {
      "aria-label": "color input ".concat(label),
      size: 32,
      value: fields === null || fields === void 0 ? void 0 : fields[label],
      maxLength: RGB_LENGTH,
      onChange: function onChange(event) {
        handleChangeInput(label, event.target.value.replace(/[^0-9]/i, ''));
      },
      onBlur: handleBlurInput
    }));
  }));
}
function decimalToFormmatedHex(decimal) {
  return decimal.toString(16).padStart(2, '0');
}
var InputRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1xwbi8m0"
} : {
  target: "e1xwbi8m0",
  label: "InputRow"
})(process.env.NODE_ENV === "production" ? {
  name: "1jkem4b",
  styles: "display:flex;align-items:center;width:100%;padding:8px;gap:7px;box-sizing:border-box;span{margin-right:4px;}input{padding-right:0;}"
} : {
  name: "1jkem4b",
  styles: "display:flex;align-items:center;width:100%;padding:8px;gap:7px;box-sizing:border-box;span{margin-right:4px;}input{padding-right:0;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { RGB, RgbInput, decimalToFormmatedHex };
//# sourceMappingURL=RgbInput.js.map
